module.exports = __webpack_public_path__ + "media/images/service/a_2-9a41c76b39c302a2baa5d9c9ae23c71e.png";